import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'

const createParticularsComposition = async (data: any): Promise<any> => {
  const result = await axios.post(`orders/products/configuration`, data)
  return result
}

export function useCreateParticularsComposition() {
  const queryClient = useQueryClient()

  return useMutation(createParticularsComposition, {
    onSuccess: () => {
      queryClient.invalidateQueries('orderProductByPriceTable')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível criar a configuração!')
    }
  })
}
